import {deepCopy} from 'helpers';
import {Paging, Sorting} from 'helpers/constants';
import {priceListItemActionTypes as types} from 'actions/actionTypes';

const initialState = {
  isLoading: false,
  inventoryLocations: [],
  inventoryLocationsLoading: false,
  pageInfo: {
    pageNumber: 1,
    pageSize: Paging.initialPageSize,
    pageSizes: Paging.pageSizes,
  },
  parentItem: null,
  parentPreviewItems: [],
  sortInfo: {
    sortOrder: Sorting.asc,
    sortColumn: 'name',
  },
};

export default function priceList(state = initialState, action) {
  switch (action.type) {
    case types.PRICE_LIST_ITEM_RESET:
      return deepCopy(initialState);

    case types.PRICE_LIST_ITEM_UPDATE_LOADING: {
      return {...state, isLoading: true};
    }

    case types.PRICE_LIST_ITEM_UPDATE_COMPLETE: {
      return {...state, isLoading: false};
    }

    case types.PRICE_LIST_GET_ITEM_LOADING: {
      return {...state, isLoading: true};
    }

    case types.PRICE_LIST_GET_ITEM_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        item: action.item,
        parentItem: null,
      };
    }

    case types.PRICE_LIST_GET_ITEM_FAIL: {
      return {...state, isLoading: false};
    }

    case types.PRICE_LIST_LOAD_PARENT_ITEMS_SUCCESS: {
      return {...state, parentPreviewItems: action.items};
    }

    case types.PRICE_LIST_ITEM_GET_INVENTORY_LOADING: {
      return {...state, inventoryLocationsLoading: true};
    }

    case types.PRICE_LIST_ITEM_GET_INVENTORY_SUCCESS: {
      return {
        ...state,
        inventoryLocationsLoading: false,
        inventoryLocations: action.itemLocations,
      };
    }

    case types.PRICE_LIST_ITEM_INVENTORY_CHANGED: {
      const updatedLocations = state.inventoryLocations.map(
        l =>
          l.inventoryLocationId === action.itemLocation.inventoryLocationId
            ? action.itemLocation
            : l,
      );
      return {...state, inventoryLocations: updatedLocations};
    }

    case types.PRICE_LIST_GET_ITEM_PARENT_SUCCESS:
      return {...state, parentItem: action.parentItem};

    case types.GET_PRICE_LIST_GROUP_ITEMS_LOADING:
      return {...state, isLoading: true};

    case types.GET_PRICE_LIST_GROUP_ITEMS_SUCCESS:
      return {...state, isLoading: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/priceListItemReducer.js